import React, { useCallback, useEffect, useState } from "react";

import FacebookSvg from "@components/icons/facebook-svg";
import PinterestSvg from "@components/icons/pinterest-svg";
import RedditSvg from "@components/icons/reddit-svg";
import TwitterSvg from "@components/icons/twitter-svg";

import { formatUrlWithLocale } from "@helpers/format-url-with-locale";

import { useGetExerciseEntrypointQuery } from "../../api/exercise-entrypoint";

function ShareIcons() {
  const { data } = useGetExerciseEntrypointQuery({
    exerciseId: 0,
  });

  let sharedUrl = "";
  if (data?.user) {
    const relativeUrl = formatUrlWithLocale(
      `/u${data.user.id}/${data.user.courseLanguage}`,
    );
    sharedUrl = window.location.origin + relativeUrl;
  }

  return (
    <ul className='mb-4 flex justify-between'>
      <li className='md:ml-3'>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${sharedUrl}/`}
          className='btn btn-quaternary btn-sm'
          rel='noopener noreferrer'
          target='_blank'
        >
          <FacebookSvg height={30} width={30} />
        </a>
      </li>
      <li className='md:ml-3'>
        <a
          href={`https://twitter.com/intent/tweet?url=${sharedUrl}/`}
          className='btn btn-quaternary btn-sm'
          rel='noopener noreferrer'
          target='_blank'
        >
          <TwitterSvg height={30} width={30} />
        </a>
      </li>
      <li className='md:ml-3'>
        <a
          href={`http://pinterest.com/pin/create/button/?url=${sharedUrl}/`}
          className='btn btn-quaternary btn-sm'
          rel='noopener noreferrer'
          target='_blank'
        >
          <PinterestSvg height={30} width={30} />
        </a>
      </li>
      <li className='md:ml-3'>
        <a
          href={`https://www.reddit.com/submit?url=${sharedUrl}/`}
          className='btn btn-quaternary btn-sm'
          rel='noopener noreferrer'
          target='_blank'
        >
          <RedditSvg height={30} width={30} />
        </a>
      </li>
    </ul>
  );
}

export default ShareIcons;
